import React, { useEffect, useState } from "react";

import Dialog from "veneer/Dialog";
import { MultiTextInput } from "veneer/MultiTextInput";
import Stack from "veneer/Stack";
import TextInput from "veneer/TextInput";

export interface WidgetConfigurationValues {
  detail: string;
  title: string;
}

interface WidgetConfigurationDialogProps {
  detailLabel: string;
  initialDetail?: string;
  initialTitle?: string;
  onCancel: () => void;
  onSave: (values: WidgetConfigurationValues) => void;
  open: boolean;
}

export default function WidgetConfigurationDialog({
  detailLabel,
  initialDetail = "",
  initialTitle = "",
  onCancel,
  onSave,
  open,
}: WidgetConfigurationDialogProps) {
  const [title, setTitle] = useState("");
  const [detail, setDetail] = useState("");

  useEffect(() => {
    setTitle(initialTitle);
    setDetail(initialDetail);
  }, [initialDetail, initialTitle, open]);

  return (
    <Dialog
      commitLabel="Save"
      dataTestId={{ component: "widget-configuration-dialog" }}
      onCancel={onCancel}
      onCommit={() => onSave({ detail, title })}
      onDismiss={onCancel}
      open={open}
      title="Configure widget"
    >
      <Stack gap={2}>
        <TextInput
          fullWidth
          label="Title"
          onChange={(value) => setTitle(value ?? "")}
          value={title}
        />
        <MultiTextInput
          dataTestId="widget-configuration-detail"
          fullWidth
          label={detailLabel}
          minRows={5}
          onChange={(value) => setDetail(value ?? "")}
          value={detail}
        />
      </Stack>
    </Dialog>
  );
}
